import { withTranslation } from "react-i18next";
import { Button, Divider } from "antd";
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { useEffect } from "react";
import { push } from "connected-react-router";

// Local
import Text from "components/Text";
import Title from "components/Title";


/**
 * Fail
 * @returns 
 */
const Fail = (props) => {

  useEffect(() => {
    if (!props.ui.globalPaymentData) {
      props.push(`/home`)
    }
  }, []) // eslint-disable-line

  return (
    <>
      <div style={{ width: '100%', margin: 'auto', marginTop: 20, backgroundColor: 'white', padding: 10 }}>
        <Title size={18}>Huho!</Title>
        <Divider style={{ margin: 10 }} />
        <Text>Une erreur est survenue lors de votre paiement...</Text>

        <Link to={`/configurator`}>
          <Button type="primary" style={{ marginTop: 10 }}>Essayer à nouveau</Button>
        </Link>
      </div>
    </>
  )
}

const stateToProps = state => ({
  ui: state.ui
})

const dispatchToProps = {
  push
}

export default connect(stateToProps, dispatchToProps)(withTranslation()(Fail));